import { initializeApp } from 'firebase/app'
import {getAnalytics} from '@firebase/analytics';
import { event } from 'vue-gtag';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID
}

const app = initializeApp(firebaseConfig)

const analytics = getAnalytics(app);

const logEvent = () => {
  return (ev, parameters) => event( `user-web-app:${ev}`, parameters)
}

function analyticsEvents () {
  return {
    CHARTER_REQUEST: 'successful_charter_request',
    REGISTRATION: 'successful_registration',
    BOOKING: 'booking_payment_successful'
  }
}

export default {
  analytics,
  logEvent: logEvent(),
  trackingEvent: analyticsEvents()
}
